import {isCoches} from '../../utils.js'
import cochesMiddlewares from './coches/index.js'
import motosMiddlewares from './motos/index.js'
import sharedMiddlewares from './shared/index.js'

const siteMiddlewares = isCoches ? cochesMiddlewares : motosMiddlewares
const middlewares = [...sharedMiddlewares, ...siteMiddlewares]

export default () => {
  middlewares.forEach(middleware => {
    window.analytics.addSourceMiddleware(middleware)
  })
}
